import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateGroupState } from "./groupsSlice";
import {
  selectPortfolio,
  selectAccount,
  selectQuoteAsset,
  selectSymbol,
} from "../navigation/navigationSelectors";
import type { AppDispatch } from "@/store";

/**
 * Non-rendering component that syncs the Redux navigation slice into the
 * "default" widget group whenever the global portfolio/account/symbol selection changes.
 *
 * Mount once inside the app (after ReduxGroupStateProvider is in the tree).
 * This means widgets in the "default" group always reflect the user's global
 * portfolio/account selection without any extra wiring.
 */
export function NavigationBridgeSync() {
  const dispatch = useDispatch<AppDispatch>();
  const portfolio = useSelector(selectPortfolio);
  const account = useSelector(selectAccount);
  const quoteAsset = useSelector(selectQuoteAsset);
  const symbol = useSelector(selectSymbol);

  useEffect(() => {
    dispatch(
      updateGroupState({
        groupId: "default",
        state: {
          selectedPortfolioId: portfolio ?? undefined,
          selectedAccountId: account ?? undefined,
          selectedQuoteAsset: quoteAsset ?? undefined,
          selectedSymbol: symbol ?? undefined,
        },
      })
    );
  }, [portfolio, account, quoteAsset, symbol, dispatch]);

  return null;
}
